import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type { HotelSettingsHotelInfoFormModel, ServerModel } from "../../../type";


type Props = {
	serverModel: ServerModel;
};

export const serverModelToInputModel = ({ serverModel }: Props): HotelSettingsHotelInfoFormModel["InputModel"] => {
	const {
		address,
		catchCopy,
		companyID,
		customTypeRoomTitle,
		email,
		facebookURL,
		geoLocation,
		hotelID,
		inSale,
		instagramURL,
		keyVisuals,
		logoImage,
		mainKeyVisual,
		name,
		tel,
		threadsURL,
		lineURL,
		twitterURL,
	} = serverModel.hotel;

	const inputModel: HotelSettingsHotelInfoFormModel["InputModel"] = {
		hotelID,
		companyID,

		address: {
			nationality: address?.nationality,
			city: address?.city ?? "",
			pref: address?.pref ?? "",
			town: address?.town ?? "",
			other: address?.other,
			postalCode: address?.postalCode,
			state: address?.state,
		},
		catchCopy: catchCopy ?? "",
		customTypeRoomTitle,
		email: email ?? "",
		facebookURL,
		geoLocation,
		inSale,
		instagramURL,
		keyVisuals: keyVisuals ?? [],
		mainKeyVisual: mainKeyVisual ?? DUMMY_IMAGE.s3Object,
		logoImage: logoImage ?? DUMMY_IMAGE.s3Object,
		name: name ?? "",
		tel: tel ?? "",
		threadsURL,
		lineURL,
		twitterURL,
	} satisfies HotelSettingsHotelInfoFormModel["InputModel"];

	return inputModel;
};
